module.exports = __webpack_public_path__ + "static/media/Mobile12345.7f5dd870.webp";